import React, { useEffect, useState } from "react";

//* import css
import cssClasses from "./UsersPage.module.css";

//* import mui
import { Box, Typography, Tab, Tabs, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

//* import store
import { useDispatch } from "react-redux";
import action from "../../../Redux Store/actions";

//* import user
import Button from "../../../Subcomponents/Button";
import DropDown from "../../../Subcomponents/DropDown";
import SearchBar from "../../../Subcomponents/Search";
import Datagrid from "../../../Subcomponents/Datagrid";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";

//* import npm
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getAllUsers,
  getUser,
  getUserByRoleName,
  getUserByUserName,
} from "../../../Services/Users";
import { getAllRoles, getUserByRoleId } from "../../../Services/Roles";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import { errorTost, infoTost, successTost } from "../../../Services/Toast";
import { sendResetPasswordMailSales } from "../../../Services/LoginService";
import { useSelector } from "react-redux";
import { supabase } from "../../../supabaseClient";
import PlusIcon from "../../../Components/Icons/PlusIcon";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import { getBlockCheck } from "../../../Services/WorkTransferApis";
import BlockWarningDialog from "../../../Components/WorkTransfer/BlockWarningDialog";

function UsersPage() {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [filterBy, setFilterBy] = useState("all");
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  const [drpDownSelectedValCrm, setDrpDownSelectedValCrm] = useState("Latest First");
  const [users, setUsers] = useState([]);
  const [DeleteUserOpen, setDeleteUserOpen] = useState(false);
  const [CannotDeleteUserOpen, setCannotDeleteUserOpen] = useState(false);
  const [DeleteUserData, setDeleteUserData] = useState([]);
  const [RemoveDeleteUserOpen, setRemoveDeleteUserOpen] = useState(false);
  const [RemoveDeleteUserData, setRemoveDeleteUserData] = useState([]);
  // FR-12 block sequencing — warn before Block only if the user has active work.
  const [blockWarningOpen, setBlockWarningOpen] = useState(false);
  const [blockCheckSummary, setBlockCheckSummary] = useState(null);
  const [checkingBlock, setCheckingBlock] = useState(false);
  const [CrmUsers, setCrmUsers] = useState([]);
  const [CrmUserCount, setCrmUserCount] = useState(0);
  const [CRMFilterBy, setCRMFilterBy] = useState("all");
  const [name, setName] = useState();
  const [CrmName, setCrmName] = useState();

  // CRM2 M1.37 (DC-132): users with CRM 2.0 access get the Sales / CRM tabs, and the
  // CRM tab gets a Project filter and a Projects column. Everyone else keeps today's
  // combined list. Link from Project › CRM 2.0 › Team: ?tab=CRM&projectId=<id>.
  const [searchParams] = useSearchParams();
  const showCrm2Tabs =
    loggedInUser?.roleId?.level == 1 || !!loggedInUser?.roleId?.accessibleTabs?.["CRM 2.0"]?.isAccessible;
  const [crmProjectFilter, setCrmProjectFilter] = useState(
    (showCrm2Tabs && searchParams.get("projectId")) || "all"
  );
  const [crmProjectList, setCrmProjectList] = useState([{ label: "All projects", value: "all" }]);
  const [crmRoleList, setCrmRoleList] = useState([{ label: "All", value: "all" }]);

  // userIds tagged to a project (Users › Assign Project); null when the read failed.
  const getUserIdsOfProject = async (projectId) => {
    const { data, error } = await supabase.from("SustenanceSalesRelations").select("userId").eq("projectId", projectId);
    if (error) {
      console.error("[crm2][UsersPage] project team read failed", { projectId, error: error.message });
      errorTost("Could not load the users of this project.");
      return null;
    }
    return [...new Set((data || []).map((r) => r.userId))];
  };

  // Adds "projects" (comma-separated project names) to each CRM user row.
  const attachProjects = async (items) => {
    const userIds = items.map((u) => u.userId);
    if (!userIds.length) return items;
    const { data, error } = await supabase
      .from("SustenanceSalesRelations")
      .select("userId, projectId(projectName)")
      .in("userId", userIds);
    if (error) {
      console.error("[crm2][UsersPage] projects column read failed", { users: userIds.length, error: error.message });
      return items.map((u) => ({ ...u, projects: "" }));
    }
    const byUser = {};
    (data || []).forEach((r) => {
      const n = r.projectId?.projectName;
      if (!n) return;
      byUser[r.userId] = byUser[r.userId] || new Set();
      byUser[r.userId].add(n);
    });
    return items.map((u) => ({ ...u, projects: [...(byUser[u.userId] || [])].sort().join(", ") }));
  };

  // Lists for the CRM tab filters: roles that CRM users have, and VJ projects.
  const loadCrmFilterLists = async () => {
    const [rolesRes, projectsRes] = await Promise.all([
      supabase.from("Users").select("roleId(roleId, title)").eq("isCrmUser", true),
      supabase.from("Projects").select("projectId, projectName").eq("isVJ", true).order("projectName", { ascending: true }),
    ]);
    if (rolesRes.error || projectsRes.error) {
      console.error("[crm2][UsersPage] CRM tab filter lists read failed", {
        roles: rolesRes.error?.message,
        projects: projectsRes.error?.message,
      });
    }
    const seen = new Map();
    (rolesRes.data || []).forEach((r) => r.roleId && seen.set(r.roleId.roleId, r.roleId.title));
    setCrmRoleList([
      { label: "All", value: "all" },
      ...[...seen].map(([value, label]) => ({ label, value })).sort((a, b) => a.label.localeCompare(b.label)),
    ]);
    setCrmProjectList([
      { label: "All projects", value: "all" },
      ...(projectsRes.data || []).map((p) => ({ label: p.projectName, value: p.projectId })),
    ]);
  };

  const getThreeDotsMenu = () => {
    let tempSideMenuArray = [];
    ["Edit", "Reset Password", "Block"].forEach((el) => {
      if (
        Object.keys(loggedInUser?.roleId?.accessibleTabs?.Users).includes(el) &&
        loggedInUser?.roleId?.accessibleTabs?.Users?.[el]?.isAccessible
      ) {
        tempSideMenuArray.push(el);
      }
    });
    return tempSideMenuArray;
  };

  const processUserData = (res) => {
    const tempSideMenuArray = getThreeDotsMenu();
    return res
      .filter((f) => f.isCrmUser === false || f.isCrmUser === null)
      .map((data, i) => ({
        id: i,
        ...data,
        roleId: data.roleId?.title,
        parentId: data.parentId?.name,
        level: data.roleId?.level,
        accessibleTabs: data.roleId?.accessibleTabs,
        threeDotsMenuUser: tempSideMenuArray,
      }));
  };

  async function fetchUsers(drpDownSelectedValue, filterValueBy) {
    //!! Query Supabase directly with isCrmUser filter — JS filter was unreliable
    const UsersFilters = {
      "Name Ascending": { key: 'name', isAscending: true },
      "Name Descending": { key: 'name', isAscending: false },
      "Oldest First": { key: 'created_at', isAscending: true },
      "Latest First": { key: 'last_updated_at', isAscending: false },
    };
    const sort = UsersFilters[drpDownSelectedValue] || UsersFilters["Latest First"];
    // Combined list: Sales + CRM + CP Sourcing (no isCrmUser filter). The
    // "User Type" column distinguishes them via isCpSourcingUser / isCrmUser.
    let query = supabase
      .from("Users")
      .select(`*, roleId(title, accessibleTabs, level), parentId(name)`, { count: "exact" })
      .order(sort.key, { ascending: sort.isAscending });
    if (filterValueBy && filterValueBy !== "all") {
      query = query.eq("roleId", filterValueBy);
    }
    // CRM2 M1.37: with the Sales / CRM tabs shown, the Sales tab lists non-CRM users only.
    if (showCrm2Tabs) {
      query = query.not("isCrmUser", "is", true);
    }
    const { data, error, count } = await query;
    if (error) console.error("[crm2][UsersPage] users read failed", { tabs: showCrm2Tabs, error: error.message });
    if (data) {
      const items = data.map((data, i) => ({
        id: i,
        ...data,
        roleId: data.roleId?.title,
        parentId: data.parentId?.name,
        level: data.roleId?.level,
        accessibleTabs: data.roleId?.accessibleTabs,
        threeDotsMenuUser: getThreeDotsMenu(),
      }));
      setUsers(items);
      setTotalCount(count || items.length);
    }
  }
  
  const dropDownFilterUser = (drpDownSelectedValue) => {
    fetchUsers(drpDownSelectedValue, filterBy);
  };
  
  const getUsersList = (drpDownSelectedValue, filterValueBy) => {
    fetchUsers(drpDownSelectedValue, filterValueBy);
  };
  
  const getUserName = async (name) => {
    //!! Search with isCrmUser filter at DB level
    let query = supabase
      .from("Users")
      .select(`*, roleId(title, accessibleTabs, level), parentId(name)`, { count: "exact" })
      .ilike("name", "%" + name + "%");
    if (showCrm2Tabs) {
      query = query.not("isCrmUser", "is", true);
    }
    const { data, count } = await query;
    if (data) {
      const items = data.map((d, i) => ({
        id: i, ...d,
        roleId: d.roleId?.title,
        parentId: d.parentId?.name,
        level: d.roleId?.level,
        accessibleTabs: d.roleId?.accessibleTabs,
        threeDotsMenuUser: getThreeDotsMenu(),
      }));
      setUsers(items);
      setTotalCount(count || items.length);
    }
  };
  
  async function filterUserByRoleId(e) {
    fetchUsers(drpDownSelectedVal, e);
    setFilterBy(e);
  }

  const processCrmUserData = (res) => {
    const tempSideMenuArray = getThreeDotsMenu();
    return res
      .filter((f) => f.isCrmUser === true)
      .map((data, i) => ({
        id: i,
        ...data,
        roleId: data.roleId?.title,
        parentId: data.parentId?.name,
        level: data.roleId?.level,
        accessibleTabs: data.roleId?.accessibleTabs,
        threeDotsMenuUser: tempSideMenuArray,
      }));
  };
  async function fetchCrmUsers(drpDownSelectedCrmValue, crmFilterValue, projectFilter = crmProjectFilter) {
    //!! Query Supabase directly with isCrmUser=true filter
    // CRM2 M1.37: Project filter = users tagged to that project in Users › Assign Project.
    let projectUserIds = null;
    if (projectFilter && projectFilter !== "all") {
      projectUserIds = await getUserIdsOfProject(projectFilter);
      if (!projectUserIds || !projectUserIds.length) {
        console.log("[crm2][UsersPage] no users tagged to the project", { projectId: projectFilter });
        setCrmUsers([]);
        setCrmUserCount(0);
        return;
      }
    }
    const UsersFilters = {
      "Name Ascending": { key: 'name', isAscending: true },
      "Name Descending": { key: 'name', isAscending: false },
      "Oldest First": { key: 'created_at', isAscending: true },
      "Latest First": { key: 'last_updated_at', isAscending: false },
    };
    const sort = UsersFilters[drpDownSelectedCrmValue] || UsersFilters["Latest First"];
    let query = supabase
      .from("Users")
      .select(`*, roleId(title, accessibleTabs, level), parentId(name)`, { count: "exact" })
      .eq("isCrmUser", true)
      .order(sort.key, { ascending: sort.isAscending });
    if (crmFilterValue && crmFilterValue !== "all") {
      query = query.eq("roleId", crmFilterValue);
    }
    if (projectUserIds) {
      query = query.in("userId", projectUserIds);
    }
    const { data, error, count } = await query;
    if (error) console.error("[crm2][UsersPage] CRM users read failed", { projectId: projectFilter, role: crmFilterValue, error: error.message });
    if (data) {
      const items = data.map((data, i) => ({
        id: i,
        ...data,
        roleId: data.roleId?.title,
        parentId: data.parentId?.name,
        level: data.roleId?.level,
        accessibleTabs: data.roleId?.accessibleTabs,
        threeDotsMenuUser: getThreeDotsMenu(),
      }));
      setCrmUsers(showCrm2Tabs ? await attachProjects(items) : items);
      setCrmUserCount(count || items.length);
    }
  }
  
  const dropDownFilterCrm = (drpDownSelectedCrmValue) => {
    fetchCrmUsers(drpDownSelectedCrmValue, CRMFilterBy);
  };
  
  const getCRMUsersList = (drpDownSelectedCrmValue, crmFilterValue) => {
    fetchCrmUsers(drpDownSelectedCrmValue, crmFilterValue);
  };
  
  async function filterUserByRoleIdToCrm(e) {
    fetchCrmUsers(drpDownSelectedValCrm, e);
    setCRMFilterBy(e);
  }

  const getCrmUserName = async (name) => {
    //!! CRM search with isCrmUser=true at DB level
    let projectUserIds = null;
    if (crmProjectFilter !== "all") {
      projectUserIds = await getUserIdsOfProject(crmProjectFilter);
      if (!projectUserIds || !projectUserIds.length) {
        setCrmUsers([]);
        setCrmUserCount(0);
        return;
      }
    }
    let query = supabase
      .from("Users")
      .select(`*, roleId(title, accessibleTabs, level), parentId(name)`, { count: "exact" })
      .eq("isCrmUser", true)
      .ilike("name", "%" + (name || "") + "%");
    if (CRMFilterBy && CRMFilterBy !== "all") {
      query = query.eq("roleId", CRMFilterBy);
    }
    if (projectUserIds) {
      query = query.in("userId", projectUserIds);
    }
    const { data, error, count } = await query;
    if (error) console.error("[crm2][UsersPage] CRM user search failed", { projectId: crmProjectFilter, error: error.message });
    if (data) {
      const items = data.map((d, i) => ({
        id: i, ...d,
        roleId: d.roleId?.title,
        parentId: d.parentId?.name,
        level: d.roleId?.level,
        accessibleTabs: d.roleId?.accessibleTabs,
        threeDotsMenuUser: getThreeDotsMenu(),
      }));
      setCrmUsers(showCrm2Tabs ? await attachProjects(items) : items);
      setCrmUserCount(count || items.length);
    }
  };

  async function filterCrmUsersByProject(projectId) {
    console.log("[crm2][UsersPage] project filter", { projectId });
    setCrmProjectFilter(projectId);
    fetchCrmUsers(drpDownSelectedValCrm, CRMFilterBy, projectId);
  }

  
  const getUserByRole = async (roleName) => {
    const data = await getUserByRole(roleName);
    // console.log("fetch by role  :", data);
  };

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "name",
        // operatorValue: '>',
        value: "ram",
      },
    ],
  });

  const [roles, SetRoles] = useState([]);

  const [tabs, setTab] = useState([
    'Sales',
    'CRM',
  ]);

  const getRoles = async () => {
    const response = await getAllRoles();

    const { data } = response;
    let items = [
      {
        label: "All",
        value: "all",
      },
    ];

    if (tabValue === 'Sales') {
      setFilterBy("all");
    } else if (tabValue === 'CRM') {
      setCRMFilterBy("all")
    }


    if (data) {
      data.map((val) => {
        items.push({
          label: val.title,
          value: val.roleId,
        });
      });

      SetRoles(items);
    }
  };

  useEffect(() => {
    dispatch(action.activeMenu("users"));
    getUsersList(drpDownSelectedVal,filterBy);
    getRoles();
  }, []);

  //!! New UI columns — initials avatar, role chip, reports to, masked phone, status chip
  const userGridColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 240,
      renderCell: (params) => {
        const val = params?.value || "";
        const initials = val.trim().split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase() || "?";
        const bgColors = ["#E6F1FB", "#EEEDFE", "#FAEEDA", "#E1F5EE", "#FCEBEB"];
        const txtColors = ["#0C447C", "#3C3489", "#633806", "#085041", "#A32D2D"];
        const idx = val ? val.charCodeAt(0) % 5 : 0;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <div style={{
              width: "3.2rem", height: "3.2rem", borderRadius: "50%",
              background: bgColors[idx], display: "flex", alignItems: "center",
              justifyContent: "center", fontSize: "1.2rem",
              fontFamily: "Inter-Medium", fontWeight: "500",
              color: txtColors[idx], flexShrink: 0,
            }}>
              {initials}
            </div>
            <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#101828" }}>
              {val}
            </div>
          </div>
        );
      },
    },
    {
      field: "roleId",
      headerName: "User Role",
      width: 180,
      renderCell: (params) => (
        <LeadStatusChip
          label={params.value || "—"}
          style={{ color: "#0C447C", backgroundColor: "#E6F1FB" }}
        />
      ),
    },
    {
      field: "userType",
      headerName: "User Type",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        // Same precedence as CreateUser: CP Sourcing → CRM → Sales.
        const t = params.row.isCpSourcingUser
          ? "CP Sourcing"
          : params.row.isCrmUser
          ? "CRM"
          : "Sales";
        const styleMap = {
          "CP Sourcing": { color: "#3C3489", backgroundColor: "#EEEDFE" },
          CRM: { color: "#B54708", backgroundColor: "#FFFAEB" },
          Sales: { color: "#027A48", backgroundColor: "#ECFDF3" },
        };
        return <LeadStatusChip label={t} style={styleMap[t]} />;
      },
    },
    {
      field: "parentId",
      headerName: "Reports To",
      width: 180,
      renderCell: (params) => params.value ? (
        <LeadStatusChip
          label={params.value}
          style={{ color: "#3C3489", backgroundColor: "#EEEDFE" }}
        />
      ) : (
        <span style={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: "#98A2B3" }}>Top Level</span>
      ),
    },
    {
      field: "contactNumber",
      headerName: "Phone",
      width: 160,
      renderCell: (params) => {
        const num = params?.value ? params.value.toString() : "";
        return (
          <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#344054" }}>
            {num.length >= 8 ? num.slice(0, 4) + "****" + num.slice(-4) : num}
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 240,
      renderCell: (params) => (
        <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 120,
      renderCell: (params) => params.row.isActive ? (
        <LeadStatusChip label={"Active"} style={{ color: "#027A48", backgroundColor: "#ECFDF3" }} />
      ) : (
        <LeadStatusChip label={"Blocked"} style={{ color: "#B42318", backgroundColor: "#FEF3F2" }} />
      ),
    },
    {
      field: "action",
      headerName: "",
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <div className={cssClasses.actionDiv}>
          <div onClick={(e) => e.stopPropagation()}>
            {params.row.isActive ? (
              <ThreeDotsMenu
                list={[...params.row.threeDotsMenuUser, "Mark as team lead"]}
                selectedValue={(e) => {
                  if (e === "Edit") {
                    // CRM2 M1.37: Edit on the CRM tab opens Assign Project (where the project tagging is changed).
                    const userTab = showCrm2Tabs && tabValue === "CRM" ? "Assigned+Projects" : "Add+Details";
                    navigate(`/home/users/createUser?userId=${params.row.userId}&userTab=${userTab}`);
                  } else if (e === "Reset Password") {
                    sendResetPasswordMailSales(params.row.email)
                      .then(() => {
                        successTost("Reset password link sent successfully to " + params.row.name + " ( " + params.row.email + " )");
                      })
                      .catch(() => {
                        errorTost("Could not send reset password link to " + params.row.name);
                      });
                  } else if (e === "Mark as team lead") {
                    supabase.from("Users").update({ isTeamLead: true }).eq("userId", params.row.userId).then((resp) => {
                      if (resp.status === 200) {
                        successTost(`${params.row.name} marked as team lead`);
                      }
                    });
                  } else if (e === "Block") {
                    if (params.row.level === 1) {
                      setCannotDeleteUserOpen(true);
                    } else {
                      // FR-12 block sequencing: check for active work first. On
                      // any check failure, fall back to the original behavior
                      // (block immediately) rather than let a Work Transfer
                      // outage block admins from using an existing feature.
                      setDeleteUserData(params.row);
                      setCheckingBlock(true);
                      getBlockCheck(params.row.userId)
                        .then((res) => {
                          if (res.success && res.data.hasActiveWork) {
                            setBlockCheckSummary(res.data.summary);
                            setBlockWarningOpen(true);
                          } else {
                            setDeleteUserOpen(true);
                          }
                        })
                        .catch(() => setDeleteUserOpen(true))
                        .finally(() => setCheckingBlock(false));
                    }
                  }
                }}
              />
            ) : (
              <ThreeDotsMenu
                list={["Unblock"]}
                selectedValue={(e) => {
                  if (e === "Unblock") {
                    setRemoveDeleteUserOpen(true);
                    setRemoveDeleteUserData(params.row);
                  }
                }}
              />
            )}
          </div>
        </div>
      ),
    },
  ];

  // CRM2 M1.37: CRM tab = today's columns + "Projects" after User Role.
  const crmGridColumns = (() => {
    const cols = [...userGridColumns];
    const at = cols.findIndex((c) => c.field === "roleId") + 1;
    cols.splice(at, 0, {
      field: "projects",
      headerName: "Projects",
      width: 280,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#344054", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {params.value || "—"}
          </div>
        </Tooltip>
      ),
    });
    return cols;
  })();

  function searchUser(e) {
    setName(e.target.value);
    getUserName(e.target.value);
  }

  function searchCrmUser(e) {
    setCrmName(e.target.value);
    getCrmUserName(e.target.value);
  }

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });

  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
  };

  const [tabValue, setTabValue] = useState(
    showCrm2Tabs && searchParams.get("tab") === "CRM" ? "CRM" : "Sales"
  );

  // CRM2 M1.37: load the CRM tab (list + its filter lists) when it is opened.
  useEffect(() => {
    if (!showCrm2Tabs || tabValue !== "CRM") return;
    console.log("[crm2][UsersPage] CRM tab opened", { projectId: crmProjectFilter });
    loadCrmFilterLists();
    fetchCrmUsers(drpDownSelectedValCrm, CRMFilterBy, crmProjectFilter);
  }, [tabValue]);

  return (
    <div className={`pageWrapper ${cssClasses.pageWrapper}`}>
      {/* ── Compact header: Users title + tabs + Add User in one row ── */}
      <Box style={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #EAECF0",
        padding: "0 0.5rem",
      }}>
        <Box style={{ display: "flex", alignItems: "center", gap: "2rem", flex: 1 }}>
          <Typography className={cssClasses.headerTittle}
            style={{ whiteSpace: "nowrap", paddingBottom: "0.4rem", margin: 0 }}>
            Users
          </Typography>
        </Box>
        <Box style={{ flexShrink: 0, paddingBottom: "0.4rem" }}>
          {loggedInUser?.roleId?.accessibleTabs?.Users?.["Add User"]?.isAccessible && (
            <Button
              style={{
                color: "#fff", backgroundColor: "#1570EF",
                fontSize: "1.4rem", lineHeight: "2rem", fontFamily: "Roboto-Regular",
              }}
              btnName={"Add User"}
              clicked={() => navigate("/home/users/createUser?userTab=Add+Details")}
              btnIcon={<PlusIcon />}
              iconPosition={"left"}
            />
          )}
        </Box>
      </Box>
      {/* CRM2 M1.37: Sales / CRM tabs in their own row below the header (prototype "Users › CRM tab") */}
      {showCrm2Tabs && (
        <Box style={{ borderBottom: "1px solid #EAECF0", marginTop: "1.2rem" }}>
          <Tabs value={tabValue} onChange={tabChange}>
            {tabList}
          </Tabs>
        </Box>
      )}
      {tabValue === "Sales" && (
        <div className={cssClasses.content} style={{ marginTop: "1.2rem" }}>
          <div className={cssClasses.actionWrapper}
            style={{ flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            {/* Count — left */}
            <span className={cssClasses.countTitle} style={{ flexShrink: 0 }}>{totalCount} Users</span>
            {/* Filters + Search — right */}
            <div style={{ display: "flex", alignItems: "center", gap: "1.6rem", flexWrap: "nowrap", marginLeft: "auto" }}>
              <div className={cssClasses.filterWrapper}>
                <div className={cssClasses.label}><p>Filter by</p></div>
                <div className={cssClasses.dropdownWrapper}>
                  <DropDown
                    onChangeSelect={(e) => filterUserByRoleId(e)}
                    selectedValue={filterBy}
                    style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                    list={roles}
                  />
                </div>
              </div>
              <div className={cssClasses.filterWrapper}>
                <div className={cssClasses.label}><p>Sort by</p></div>
                <div className={cssClasses.dropdownWrapper}>
                  <DropDown
                    list={["Name Ascending", "Name Descending", "Latest First", "Oldest First"]}
                    style={{ background: '#f2f4f7', selectedColor: '#667085' }}
                    selectedValue={drpDownSelectedVal}
                    onChangeSelect={(_value) => { dropDownFilterUser(_value); setDrpDownSelectedVal(_value); }}
                  />
                </div>
              </div>
              <SearchBar placeholder={"Search by user name"} search={searchUser} id={"userSearchBar"} />
            </div>
          </div>
          <div className={cssClasses.gridWrapper} style={{ height: "calc(100vh - 22rem)" }}>
            <Datagrid
              hideFooter={false}
              columns={userGridColumns}
              rows={users}
              style={{
                "& .MuiDataGrid-row": { cursor: "default" },
              }}
            />
          </div>
        </div>
      )}

      {tabValue === "CRM" && (
        <div className={cssClasses.content} style={{ marginTop: "1.2rem" }}>
          <div className={cssClasses.actionWrapper}
            style={{ flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span className={cssClasses.countTitle} style={{ flexShrink: 0 }}>{CrmUserCount} Users</span>
            <div style={{ display: "flex", alignItems: "center", gap: "1.6rem", flexWrap: "nowrap", marginLeft: "auto" }}>
              <div className={cssClasses.filterWrapper}>
                <div className={cssClasses.label}><p>Filter by</p></div>
                <div className={cssClasses.dropdownWrapper}>
                  <DropDown
                    onChangeSelect={(e) => filterUserByRoleIdToCrm(e)}
                    selectedValue={CRMFilterBy}
                    style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                    list={showCrm2Tabs ? crmRoleList : roles}
                  />
                </div>
              </div>
              {showCrm2Tabs && (
                <div className={cssClasses.filterWrapper}>
                  <div className={cssClasses.label}><p>Project</p></div>
                  <div className={cssClasses.dropdownWrapper}>
                    <DropDown
                      onChangeSelect={(e) => filterCrmUsersByProject(e)}
                      selectedValue={crmProjectFilter}
                      style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                      list={crmProjectList}
                    />
                  </div>
                </div>
              )}
              <div className={cssClasses.filterWrapper}>
                <div className={cssClasses.label}><p>Sort by</p></div>
                <div className={cssClasses.dropdownWrapper}>
                  <DropDown
                    list={["Name Ascending", "Name Descending", "Latest First", "Oldest First"]}
                    style={{ background: '#f2f4f7', selectedColor: '#667085' }}
                    selectedValue={drpDownSelectedValCrm}
                    onChangeSelect={(_value) => { dropDownFilterCrm(_value); setDrpDownSelectedValCrm(_value); }}
                  />
                </div>
              </div>
              <SearchBar placeholder={"Search by user name"} search={searchCrmUser} id={"userSearchBar"} />
            </div>
          </div>
          <div className={cssClasses.gridWrapper} style={{ height: "calc(100vh - 22rem)" }}>
            <Datagrid
              hideFooter={false}
              columns={showCrm2Tabs ? crmGridColumns : userGridColumns}
              rows={CrmUsers}
              style={{
                "& .MuiDataGrid-row": { cursor: "default" },
              }}
            />
          </div>
        </div>
      )}

      {DeleteUserOpen && (
        <ConfirmationAlert
          open={DeleteUserOpen}
          close={() => setDeleteUserOpen(false)}
          buttonTitle={'No'}
          title={'Warning'}
          subTitle={'Are you sure you want to Block?'}
          returnRespButton={'Yes'}
          confirm={(value) => {
            console.log("value", value)
            console.log("user-value", DeleteUserData)
            if (value === 'confirmed') {
              supabase.from('Users').update({ isActive: false }).eq('userId', DeleteUserData.userId).then((resp) => {
                if (resp.status === 200) {
                  successTost(`${DeleteUserData.name} was blocked successfully!`)
                  setDeleteUserOpen(false)
                  if (tabValue === "Sales") {
                   filterBy ? filterUserByRoleId(filterBy) :getUsersList(drpDownSelectedVal,filterBy);
                  } else if (tabValue === "CRM") {
                    CRMFilterBy? filterUserByRoleIdToCrm(CRMFilterBy): getCRMUsersList(drpDownSelectedValCrm,CRMFilterBy);
                  }
                }
              })
            } else if (value === 'rejected') {
              setDeleteUserOpen(false)
            }
          }}
        />
      )}

      <BlockWarningDialog
        open={blockWarningOpen}
        onClose={() => setBlockWarningOpen(false)}
        userName={DeleteUserData?.name}
        summary={blockCheckSummary}
        onTransferFirst={() => {
          setBlockWarningOpen(false);
          navigate('/home/WorkTransfer/MoveWork');
        }}
        onBlockAnyway={() => {
          setBlockWarningOpen(false);
          setDeleteUserOpen(true);
        }}
      />

      {RemoveDeleteUserOpen && (
        <ConfirmationAlert
          open={RemoveDeleteUserOpen}
          close={() => setRemoveDeleteUserOpen(false)}
          buttonTitle={'No'}
          title={'Warning'}
          subTitle={'Are you sure you want to Unblock?'}
          returnRespButton={'Yes'}
          confirm={(value) => {
            console.log("value", value)
            console.log("user-value", RemoveDeleteUserData)
            if (value === 'confirmed') {
              supabase.from('Users').update({ isActive: true }).eq('userId', RemoveDeleteUserData.userId).then((resp) => {
                if (resp.status === 200) {
                  successTost(`${RemoveDeleteUserData.name} was Unblocked successfully!`)
                  setRemoveDeleteUserOpen(false)
                  if (tabValue === "Sales") {
                    filterBy ? filterUserByRoleId(filterBy) :getUsersList(drpDownSelectedVal,filterBy);
                  } else if (tabValue === "CRM") {
                    CRMFilterBy? filterUserByRoleIdToCrm(CRMFilterBy): getCRMUsersList(drpDownSelectedValCrm,CRMFilterBy);
                  }
                }
              })
            } else if (value === 'rejected') {
              setRemoveDeleteUserOpen(false)
            }
          }}
        />
      )}

      {CannotDeleteUserOpen && (
        <ConfirmationAlert
          open={CannotDeleteUserOpen}
          close={() => setCannotDeleteUserOpen(false)}
          // buttonTitle={'No'}
          title={'Warning'}
          subTitle={'This User cannot be blocked as per the level of User'}
          returnRespButton={'OK'}
          confirm={(value) => {
            if (value === 'confirmed') {
              setCannotDeleteUserOpen(false)
            }
          }}
        />
      )}
    </div>
  );
}

export default UsersPage;
